
var modal = document.getElementById('videoModal');
var btn = document.getElementById('openModal');
var closeBtn = document.querySelector('.modal-close');
var video = document.getElementById('modalVideo');

// 開くとき
btn.addEventListener('click', () => {
  modal.classList.add('active');

  // ブラウザの自動再生制限対策
  video.muted = true; // 明示的に muted に設定
  video.currentTime = 0;

  // フェードイン後に再生（アニメーション0.3s後）
  setTimeout(() => {
    var playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise.catch(() => {
        console.warn('自動再生がブロックされました');
      });
    }
  }, 300);
});

// 閉じるとき
function closeModal() {
  // まずフェードアウト
  modal.classList.remove('active');

  // フェードアウト後（0.4s）に停止してリセット
  setTimeout(() => {
    video.pause();
    video.currentTime = 0;
  }, 400);
  console.log('動画状態:', video.paused ? '停止中' : '再生中', '再生位置', video.currentTime);

}

closeBtn.addEventListener('click', closeModal);

// 背景クリックでも閉じる
modal.addEventListener('click', e => {
  if (e.target === modal) closeModal();
});


